import { createStrictContext } from "@indietabletop/appkit";
import { useReducer, type ActionDispatch } from "react";

export type PrintSettings = {
  layout: "SUMMARIES" | "CARDS";
  showKnights: boolean;
};

type PrintContextValue = PrintSettings & {
  dispatch: ActionDispatch<[Partial<PrintSettings>]>;
};

export const [PrintContext, usePrintContext] =
  createStrictContext<PrintContextValue>("Print Context");

function reducer(state: PrintSettings, action: Partial<PrintSettings>) {
  return { ...state, ...action };
}

export function usePrintSettings() {
  return useReducer(reducer, {
    layout: "SUMMARIES",
    showKnights: true,
  });
}
